import type { OffsiteConfig } from "@/engine/app/offsite-config";
import { SLIDE_COMPONENTS } from "./deck";
import "./tokens.css";

export const config: OffsiteConfig = {
  id: "netzkunden",
  displayName: "Offsite Netzkundenmanagement",
  subdomain: "netzkunden.offsite.svoos.de",
  apiBaseUrl: "https://api.netzkunden.offsite.svoos.de",
  deck: SLIDE_COMPONENTS,
  // Deck-Reihenfolge in ./deck.ts: Workshop ab Folie 16, SVO OS ab 18,
  // Reveal ab 20.
  progressCuts: [
    { atSlide: 16, label: "Interaktiver Workshop", icon: "⚡" },
    { atSlide: 18, label: "SVO OS", icon: "◆" },
    { atSlide: 20, label: "Reveal", icon: "✨" },
  ],
  // Slide13LiveLauf steht im Deck an 0-basiertem Index 16 (Folie 17).
  overnightAnnouncementSlide: 16,
  phases: [
    "intro",
    "topics",
    "voting",
    "grouping",
    "working",
    "evaluating",
    "evaluated",
    "showcase",
    "reveal",
  ],
  ai: { evalPromptKey: "netzkunden", overnightPromptKey: "netzkunden" },
  // Ein Tag, Reveal am Nachmittag — kein „über Nacht".
  overnightWaitLabel:
    "Die KI baut gerade aus eurer Anforderung einen Prototypen — das Ergebnis seht ihr heute Nachmittag auf der Leinwand.",
  // Gleichstand beim Themen-Voting entscheidet das Los (animierte Auslosung).
  tieBreakRandom: true,
  ergebnisse: {
    // Mit /index.html: ohne die Datei im Pfad lösen die relativen Links der
    // Seite eine Ebene zu hoch auf und landen in der App statt beim Prototyp.
    url: "https://netzkunden.offsite.svoos.de/ergebnisse/nk-68e5024a9c7a07e2540ae36a20930b67d20d5d2486cee581/index.html",
    label: "Die Ergebnisse vom 22.09. — Auswertung und alle Prototypen",
  },
  // Die zwei gesetzten Themen — ein Klick im Pult statt Tippen vor Publikum.
  // Die zwei Publikums-Themen erfasst der Moderator live dazu.
  preparedTopics: [
    {
      short: "Leistungsreservierungs-Übersicht",
      full: "Leistungsreservierungs-Übersicht: Eine kleine App, die alle laufenden Reservierungen für Einspeisungen bündelt und auf einen Blick zeigt, was wann frei wird, was kollidiert und wo es eng wird.",
    },
    {
      short: "BNetzA-Netzbetreiber-Fragebogen",
      full: "BNetzA-Netzbetreiber-Fragebogen: Erfassung über alle Bereiche — wie viele Hausanschlüsse, Durchlaufzeiten, Anlagengrößen usw. — an einer Stelle zusammenführen statt mühsam einzusammeln.",
    },
  ],
};
